<template>
  <el-dialog
      class="select-dialog"
      title="选择类别"
      :visible.sync="dialogVisible"
      width="70%"
      top="10px"
      append-to-body>
    <div class="custom-tree-container">
      <div style="margin: 20px 40px 0px 0px;">
        <el-tree
            :data="data"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <div style="width: 100%;" @click="onSelect(data)">{{node.label}}</div>
          </span>
        </el-tree>
      </div>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    name:"ProductCategorySelector",
    data() {
      return {
        dialogVisible: false,
        data: [],
        defaultProps: {
          children: "children",
          label: "name",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic","productCategories").then((res) => {
            if (res) {
              this.data = JSON.parse(JSON.stringify(res));
            } else {
              this.$message.error("获取数据出错");
            }
          });
      },
      onSelect(data) {
        this.$emit("select", {"id": data.id, "name": data.name, "templateID": data.templateID});
        this.dialogVisible = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
